import Swiper from 'swiper';
import { Thumbs, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/thumbs';
// import 'swiper/css/effect-fade';

export default function (element, data) {
    const thumbsEl = element.querySelector('.swiper-thumbs');

    if(thumbsEl) {
        const thumbsSwiper = new Swiper(thumbsEl, {
            modules: [Thumbs],
            direction: 'horizontal',
            slidesPerView: 2,
            spaceBetween: 5,
            freeMode: true,
            watchSlidesProgress: true,
            loop: false,
            breakpoints: {
                1240: {
                    spaceBetween: 14,
                    direction: 'vertical',
                    slidesPerView: 4,
                },
                // 1240: {
                //     slidesPerView: 4,
                //     direction: 'vertical',
                // },
                992: {
                    direction: 'vertical',
                    slidesPerView: 3
                },
                768: {
                    slidesPerView: 4,
                    direction: 'horizontal',
                },
                560: {
                    slidesPerView: 3,
                    direction: 'horizontal',
                }
            },
        });

        element.swiper = new Swiper(element.querySelector('.swiper-product'), {
            modules: [Thumbs, Navigation],
            slidesPerView: 1,
            speed: 300,
            allowTouchMove: false,
            loop: true,
            thumbs: {
                swiper: thumbsSwiper,
            },
            navigation: {
                nextEl: element.querySelector('.swiper-button_next'),
                prevEl: element.querySelector('.swiper-button_prev'),
            }
        });
    }
};